
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/horoscope/[signName]",
      function () {
        return require("private-next-pages/horoscope/[signName].tsx");
      }
    ]);
  